import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    { 
        path: '/',
        name: 'Landing',
        component: () => import(/* webpackChunkName: "orders" */ "./views/Landing.vue")
    },
    { 
        path: '/Profile',
        name: 'Profile',
        component: () => import(/* webpackChunkName: "orders" */ "./views/Profile.vue")
    },
    { 
        path: '/Projects',
        name: 'Projects',
        component: () => import(/* webpackChunkName: "orders" */ "./views/Projects.vue")
    },
    { 
        path: '/Contact',
        name: 'Contact',
        component: () => import(/* webpackChunkName: "orders" */ "./views/Contact.vue")
    },
    { 
        path: '/Thanks',
        name: 'SubmissionSuccess',
        component: () => import(/* webpackChunkName: "orders" */ "./views/SubmissionSuccess.vue")
    },
    { 
        path: '/Fail',
        name: 'SubmissionFail',
        component: () => import(/* webpackChunkName: "orders" */ "./views/SubmissionFail.vue")
    }
];

const router = new VueRouter({
    mode: 'history',
    routes
});

export default router;